import Vue from 'vue';
import { $http } from '@/utils/https';
import { fixBody } from '@/helpers/variables/index';

import {
    SET_LOADING_AVAILABILITY_PROPS,
    SET_AVAILABILITY_PROPS,
    SHOW_POPUP_AVAILABILITY_PROPS,
    DECREMENT_AVAILABILITY_PROPS,
    INCREMENT_AVAILABILITY_PROPS,
    RESET_AVAILABILITY_PROPS,
    SET_CURRENT_REQUISITE,
    SHOW_POPUP_BASKET,
    SET_CURRENT_DATE_REQUISITE,
    SET_COUNT_AVAILABILITY_PROPS
} from '../mutation-types';

import {
    CHECK_AVAILABILITY_PROPS,
} from '../action-types';


const state = {
    currentRequisite: null,
    currentDates: {
        to: '',
        from: ''
    },
    count: 1,
    showPopupBasket: false,
    showPopupCheckAvailability: false,
    disabledDates: [],
    disabledDatesLoading: false
};

const getters = {
    currentDates: state => state.currentDates,
    currentRequisite: state => state.currentRequisite,
    showPopupBasket: state => state.showPopupBasket,
    showPopupCheckAvailability: state => state.showPopupCheckAvailability,
    count: state => state.count,
    disabledDates: state => state.disabledDates,
    disabledDatesLoading: state => state.disabledDatesLoading,
};

const actions = {
    [CHECK_AVAILABILITY_PROPS]: async ({ commit }, payload) => {
        commit(SET_LOADING_AVAILABILITY_PROPS, true);
        try {
            const response = await $http.get(`v1/product/${payload.slug}/available?from=${payload.from}&to=${payload.to}`);
            commit(SET_AVAILABILITY_PROPS, response.data);
        }catch (e) {
            throw e;
        }finally {
            commit(SET_LOADING_AVAILABILITY_PROPS, false);
        }
    },
};

const mutations = {
    [SET_AVAILABILITY_PROPS](state, list) {
        state.disabledDates = list;
    },
    [SET_LOADING_AVAILABILITY_PROPS](state, status) {
        state.disabledDatesLoading = status;
    },
    [SET_CURRENT_REQUISITE](state, id) {
        state.currentRequisite = id;
    },
    [SET_CURRENT_DATE_REQUISITE](state, payload) {
        state.currentDates = payload;
    },
    [SHOW_POPUP_AVAILABILITY_PROPS](state, status) {
        state.showPopupCheckAvailability = status;
        fixBody(status);
    },
    [SHOW_POPUP_BASKET](state, status) {
        state.showPopupBasket = status;
        fixBody(status);
    },
    [DECREMENT_AVAILABILITY_PROPS](state) {
        if(state.count > 1) {
            state.count--;
        }
    },
    [SET_COUNT_AVAILABILITY_PROPS](state, count) {
        Vue.set(state, 'count', count);
    },
    [INCREMENT_AVAILABILITY_PROPS](state) {
        state.count++;
    },
    [RESET_AVAILABILITY_PROPS](state) {
        state.count = 1;
        state.disabledDates = [];
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
